import './errorMessage.scss';

import { useIntl } from 'react-intl';
import { Alert, AlertStatus } from '@eliberty/design-system-react';

interface ErrorMessageProps {
  messageId: string;
  defaultMessage: string;
}

const ErrorMessage = ({ messageId, defaultMessage }: ErrorMessageProps) => {
  const intl = useIntl();

  return (
    <Alert
      className='ErrorMessage'
      status={AlertStatus.Negative}
      title={intl.formatMessage({ defaultMessage, id: messageId })}
    />
  );
};

export default ErrorMessage;
